import React, { useState } from "react";
import { useEffect } from "react";
import Navbar from "../../pages/Dashboard/Navbar";
import "./settings.css";
import { connect } from "react-redux";
import { compose } from "redux";
import { apiGetUserSettings } from "../../services/api.js/backend";
import {
  setSocialSecurityTaxes,
  setMedicareTaxes,
  setGrowthRate,
  setStateTaxes,
  setFederalTaxes
} from "../../store/modules/taxes/actions";

const Settings = ({
  user,
  taxes,
  setSocialSecurityTaxes,
  setMedicareTaxes,
  setGrowthRate,
  setStateTaxes,
  setFederalTaxes
}) => {
  const [socialSecurity, setSocialSecurity] = useState(0);
  const [medicare, setMedicare] = useState(0);
  const [growth, setGrowth] = useState(0);
  const [taxesState, setTaxesState] = useState(0);
  const [taxesFederal, setTaxesFederal] = useState(0);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "securityTax") {
      setSocialSecurity(value);
    } else if (name === "medicareTax") {
      setMedicare(value);
    } else if (name === "growthRate") {
      setGrowth(value);
    } else if (name === "stateTax") {
      setTaxesState(value);
    } else if (name === "federalTax") {
      setTaxesFederal(value);
    }
  };

  const saveTaxes = () => {
    try {
      setSocialSecurityTaxes(Number(Number(socialSecurity).toFixed(2)));
      setMedicareTaxes(Number(Number(medicare).toFixed(2)));
      setGrowthRate(Number(Number(growth).toFixed(3)));
      setStateTaxes(Number(Number(taxesState).toFixed(3)));
      setFederalTaxes(Number(Number(taxesFederal).toFixed(3)));

      window.alert("New settings have been saved!");
    } catch (e) {
      window.alert("Errorsp: " + e);
    }
  };

  const handleOnClickGPT = async (type) => {
    const response = await apiGetUserSettings();

    if(type === "securityTax") setSocialSecurity(response?.securityTax.toFixed(2));
    else if(type === "medicareTax") setMedicare(response?.medicareTax.toFixed(2));
    else if(type === "growthRate") setGrowth(response?.growthRate.toFixed(2));
    else if(type === "stateTax") setTaxesState(response?.stateTax.toFixed(2));
    else if(type === "federalTax") setTaxesFederal(response?.federalTax.toFixed(2));
  };

  useEffect(() => {
    setSocialSecurity(Number(taxes.socialSecurity).toFixed(2));
    setMedicare(Number(taxes.medicare).toFixed(2));
    setGrowth(Number(taxes.growthRate).toFixed(2));
    setTaxesState(Number(taxes.stateTax).toFixed(2));
    setTaxesFederal(Number(taxes.federalTax).toFixed(2));
  }, [taxes]);

  return (
    <>
      <Navbar />
      <div className="settingsContainer">
        <h1 className="settingsTxt">Settings</h1>

        <hr />
        <div className="settingsContent">
          <label htmlFor="securityTax">
            <span>
              Social Security Taxes <sub>(in %)</sub> :
            </span>
            <button onClick={() => handleOnClickGPT("securityTax")}>🤖</button>
            <input
              name="securityTax"
              type="number"
              step="0.1"
              id="securityTax"
              value={socialSecurity}
              onChange={handleChange}
            />
          </label>

          <label htmlFor="medicareTax">
            <span>
              Medicare Taxes <sub>(in %)</sub> :
            </span>
            <button onClick={() => handleOnClickGPT("medicareTax")}>🤖</button>
            <input
              name="medicareTax"
              type="number"
              step="0.1"
              id="medicareTax"
              value={medicare}
              onChange={handleChange}
            />
          </label>

          <label htmlFor="growthRate">
            <span>
              Growth Rate <sub>(in %)</sub> :
            </span>
            <button onClick={() => handleOnClickGPT("growthRate")}>🤖</button>
            <input
              name="growthRate"
              type="number"
              step="0.1"
              id="growthRate"
              value={growth}
              onChange={handleChange}
            />
          </label>

          <label htmlFor="stateTax">
            <span>
              State Taxes <sub>(in %)</sub> :
            </span>
            <button onClick={() => handleOnClickGPT("stateTax")}>🤖</button>
            <input
              name="stateTax"
              type="number"
              step="0.1"
              id="stateTax"
              value={taxesState}
              onChange={handleChange}
            />
          </label>

          <label htmlFor="federalTax">
            <span>
              Federal Taxes<sub>(in %)</sub> :
            </span>
            <button onClick={() => handleOnClickGPT("federalTax")}>🤖</button>
            <input
              name="federalTax"
              type="number"
              step="0.1"
              id="federalTax"
              value={taxesFederal}
              onChange={handleChange}
            />
          </label>

          <div className="saveBtnContainer">
            <div></div>
            <button className="saveBtn" onClick={saveTaxes}>
              Save
            </button>
          </div>
        </div>

        <hr />
      </div>
    </>
  );
};

export default compose(
  connect(null, { setSocialSecurityTaxes, setMedicareTaxes, setGrowthRate, setStateTaxes, setFederalTaxes })
)(Settings);
